exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".current-link[data-v-1195b346]{color:#ff6200}.dropdown-item[data-v-1195b346]{font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-1195b346&scoped=true!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/NavbarDropdown.vue
// module id = 218
// module chunks = 0